import styled from 'styled-components'
import Navigation from 'components/navigation'
import Wrapper from 'common/wrapper'
import Footer from 'common/footer'
import { H2 as h2, P as p, Typography } from 'common/typography'
import OpenGraph from 'common/open-graph'

const P = styled(p)`
  line-height: 28px;
  margin: 16px 0;
`

const TerminosStyled = styled.div`
  margin-block-start: 40px;
  margin-block-end: 40px;
  h1 {
    color: var(--baseSecondary);
    margin-block-end: 8px;
  }
  .msi {
    margin-block-start: 40px;
    padding-block-start: 90px;
    ul {
      list-style: initial;
    }
  }
  @media(min-width: 768px) {
    margin-block-start: 48px;
    margin-block-end: 80px;
  }
`

function Terminos() {
  return (
    <>
      <OpenGraph
        title="Terminos y condiciones | LeonidasEsteban"
        keyword="privacidad"
      />
      <Navigation position="static" />
      <TerminosStyled>
        <Wrapper maxWidth={580}>
          <Typography small="headline4" large="headline3" as="h1">Terminos y Condiciones</Typography>
          <P>
            El usuario y/o suscriptor en todo momento deberá usar los servicios y cursos del sitio web acorde a las funcionalidades permitidas en el propio sitio y a los usos autorizados en los presentes Términos y Condiciones, por lo que se obliga a utilizarlos de tal modo que no contravengan las buenas costumbres, los derechos de terceros, las normas de uso y convivencia en Internet, las leyes de los Estados Unidos Mexicanos y la legislación vigente en el país en que el usuario se encuentre al acceder al sitio y usar los servicios y contenidos de Leonidas Esteban. El Sitio es para el uso individual del usuario y/o suscriptor, por lo que no podrá comercializar de manera alguna los servicios y cursos.
          </P>
          <P>
            El usuario y/o suscriptor acepta expresamente y se compromete, de manera enunciativa mas no limitativa, a no distribuir, transmitir, modificar, reproducir, ejecutar, ceder, vender u otorgar licencias sobre la totalidad de la información, los datos obtenidos o expedidos en función de los servicios y cursos de Leonidas Esteban, ya sea en el sitio web, softwares, o cualesquiera de los medios en los que haya accedido a la misma. La configuración de alguna de estas conductas podría derivar en la eliminación de su cuenta y/o la cancelación de la suscripción e inclusive en la comisión de un delito y/o infracción de conformidad con las leyes aplicables en la materia.
          </P>
          <Typography font="regularBold">Suscripciones</Typography>
          <P>
            Todas nuestras suscripciones son de renovación automática, puedes ver cuando se renuevan desde tu perfil y si deseas cancelar cualquier suscripción solo escribe a nuestro email de contacto
            {' '}
            <a href="mailto:leonidasesteban.com">me@leonidasesteban.com</a>
            {' '}
            o directamente desde tu perfil de estudiante.
          </P>
          <Typography font="regularBold">/Proyectos</Typography>
          <P>
            El usuario tendrá a su disposición todos los proyectos de la plataforma pero solo podrá desarrollar un máximo de 5 proyectos de forma paralela, esto sin incluir los proyectos que hagan parte de algún curso o taller.
          </P>
          <Typography font="regularBold">Usos autorizados</Typography>
          <ul>
            <li>
              <P>Reproducción en código y publicación para fines no lucrativos</P>
            </li>
          </ul>
          <Typography font="regularBold">Usos no autorizados</Typography>
          <ul>
            <li>
              <P>Adjudicación de autoría</P>
            </li>
          </ul>
          <div className="msi" id="msi">
            <Typography font="regularBold">Meses Sin Intereses</Typography>
            <P>Los meses sin intereses solo aplican para México.</P>
            <P>El método de pago debe ser una tarjeta de crédito emitida en México.</P>
            <P>La tarjeta debe ser una tarjeta de consumo; las cuotas no admiten tarjetas corporativas.</P>
            <P>La tarjeta debe ser emitida por uno de nuestros emisores admitidos.</P>
            <Typography font="regularBold">Tarjetas Aceptadas</Typography>
            <ul>
              <li><P>Afirme</P></li>
              <li><P>American Express</P></li>
              <li><P>BanBajío</P></li>
              <li><P>Banca Mifel</P></li>
              <li><P>Banco Azteca</P></li>
              <li><P>Banco Famsa</P></li>
              <li><P>Banco Invex</P></li>
              <li><P>Banjercito</P></li>
              <li><P>Banorte</P></li>
              <li><P>Banregio</P></li>
              <li><P>BBVA</P></li>
              <li><P>Citibanamex</P></li>
              <li><P>HSBC</P></li>
              <li><P>Inbursa</P></li>
              <li><P>Liverpool</P></li>
              <li><P>Nubank</P></li>
              <li><P>Santander</P></li>
              <li><P>Scotiabank</P></li>
            </ul>
          </div>
          <div className="msi" id="planes-de-financiamiento">
            <Typography font="regularBold">Planes de financiamiento</Typography>
            <P>Puedes pagar con tu tarjeta de crédito o débito desde cualquier parte del mundo.</P>
            <P>Se te hará un cargo mensual por el monto y el periodo de tiempo que elijas.</P>
            <P>Tendrás acceso a todos los beneficios de una suscripción anual desde el momento en el que te unas y los conservaras durante todo el año.</P>
            <P>
              En caso de
              <Typography font="regularBold" as="span"> INCUMPLIR </Typography>
              con un pago, los beneficios de tu suscripción anual serán cancelados.
            </P>
            <P>Al cabo de un año tu plan de financiamiento se renovará automáticamente con las mismas condiciones del primer año.</P>
          </div>
        </Wrapper>
      </TerminosStyled>
      <Footer />
    </>
  )
}

export default Terminos
